(function(){
  try {
    function patchImages() {
      var I = (window.T4SThemeSP && T4SThemeSP.Images) || null;
      if (!I) return;
    var removeProtocol = I.removeProtocol || function(u){ return String(u || '').replace(/^http(s)?:/, ''); };
    
    // Enhanced logo detection function
    function isLogoImage(url) {
      if (!url) return false;
      var lowerUrl = url.toLowerCase();
      return lowerUrl.includes('logo') || 
             lowerUrl.includes('header__') || 
             lowerUrl.includes('t4s-header__logo') ||
             lowerUrl.includes('brand') ||
             lowerUrl.includes('corby') ||
             lowerUrl.includes('kent') ||
             lowerUrl.includes('traders');
    }
    
    // Safe lazyload URL builder - use reasonable width instead of width=1
    I.lazyloadImagePath = function(u){
      if (!u || u === 'undefined' || u === 'null' || u === undefined || u === null) return '';
      
      // Convert to string and check for undefined patterns
      var urlStr = String(u || '');
      if (!urlStr || urlStr === 'undefined' || urlStr === 'null' || 
          urlStr.indexOf('undefined') > -1 || urlStr.indexOf('/products/undefined') > -1) {
        return '';
      }
      
      // Special handling for logo images - don't use width=1
      if (isLogoImage(urlStr)) {
        var sep = urlStr.indexOf('?') > -1 ? '&' : '?';
        // Use original width or reasonable default for logos
        return removeProtocol(urlStr + sep + 'width=300');
      }
      
      var sep = urlStr.indexOf('?') > -1 ? '&' : '?';
      // Use width=100 for lazy loading instead of width=1 to ensure images are visible
      return removeProtocol(urlStr + sep + 'width=100');
    };
    
    // Safe generic URL builder - enhanced with undefined checks
    I.getNewImageUrl = function(u, w, h){
      // Early return for invalid inputs
      if (!u || u === 'undefined' || u === 'null' || u === undefined || u === null) return null;
      
      // Convert to string and check for undefined patterns
      var urlStr = String(u || '');
      if (!urlStr || urlStr === 'undefined' || urlStr === 'null' || 
          urlStr.indexOf('undefined') > -1 || urlStr.indexOf('/products/undefined') > -1) {
        return null;
      }
      
      w = w || 0; h = h || 0;
      if (!w && !h) return null;
      
      var out = urlStr;
      if (w) { 
        var s1 = out.indexOf('?') > -1 ? '&' : '?'; 
        out = out + s1 + 'width=' + w; 
      }
      if (h) { 
        var s2 = out.indexOf('?') > -1 ? '&' : '?'; 
        out = out + s2 + 'height=' + h; 
      }
      
      // Final check before returning
      if (out.indexOf('undefined') > -1 || out.indexOf('/products/undefined') > -1) {
        return null;
      }
      
      return removeProtocol(out);
    };
    
    // Comprehensive image fix function - enhanced to block undefined URLs first
    function fixAllImages() {
      // FIRST: Remove all images with undefined URLs to prevent 404 requests
      var undefinedImages = document.querySelectorAll('img[src*="undefined"], img[data-src*="undefined"], img[src*="/products/undefined"], img[data-src*="/products/undefined"]');
      undefinedImages.forEach(function(img) {
        var src = img.src || img.getAttribute('data-src') || '';
        if (src && (src.indexOf('undefined') > -1 || src.indexOf('/products/undefined') > -1)) {
          // Remove the bad URL immediately
          img.removeAttribute('src');
          img.removeAttribute('data-src');
          img.style.display = 'none';
          img.classList.add('kt-bad-src');
        }
      });
      
      // THEN: Fix images with width=1 and extreme width values
      var images = document.querySelectorAll('img[src*="width="], img[data-src*="width="]');
      images.forEach(function(img) {
        var src = img.src || img.getAttribute('data-src') || '';
        // Skip if already marked as bad or contains undefined
        if (!src || src.indexOf('undefined') > -1 || img.classList.contains('kt-bad-src')) return;
        
        if (src && (src.includes('width=1') || src.includes('width=30025') || src.includes('width=70') || src.includes('width=80'))) {
          // Replace problematic width values with reasonable widths
          var newWidth = isLogoImage(src) ? '300' : '200';
          var newSrc = src.replace(/width=(1|30025|70|80)/g, 'width=' + newWidth);
          if (img.src) img.src = newSrc;
          if (img.getAttribute('data-src')) img.setAttribute('data-src', newSrc);
        }
      });
      
          // Fix background images with problematic width values
    var elements = document.querySelectorAll('[style*="background-image"]');
    elements.forEach(function(el) {
      var style = el.getAttribute('style') || '';
      if (style.includes('width=1') || style.includes('width=30025') || style.includes('width=70') || style.includes('width=80')) {
        var newStyle = style.replace(/width=(1|30025|70|80)/g, 'width=200');
        el.setAttribute('style', newStyle);
      }
    });
      
          // Force reload of broken images
    var brokenImages = document.querySelectorAll('img[src*="width=1"], img[src*="width=30025"], img[src*="width=70"], img[src*="width=80"]');
    brokenImages.forEach(function(img) {
      if (img.complete && img.naturalWidth === 0) {
        var src = img.src;
        img.src = '';
        setTimeout(function() {
          img.src = src.replace(/width=(1|30025|70|80)/g, 'width=200');
        }, 100);
      }
    });
    }
    
    // Run fix on load and after DOM changes
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixAllImages);
    } else {
      fixAllImages();
    }
    
    // Also fix images that get added dynamically - with throttling to prevent 429 errors
    var lastFixTime = 0;
    var fixThrottle = 500; // Minimum 500ms between fixes
    var pendingFix = null;
    
    var observer = new MutationObserver(function(mutations) {
      var needsFix = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check for undefined URLs first (most critical)
              var badImages = node.querySelectorAll ? node.querySelectorAll('img[src*="undefined"], img[data-src*="undefined"], img[src*="/products/undefined"]') : [];
              if (badImages.length > 0) {
                // Immediately remove bad images to prevent 404 requests
                badImages.forEach(function(img) {
                  img.removeAttribute('src');
                  img.removeAttribute('data-src');
                  img.style.display = 'none';
                });
                needsFix = true;
              }
              // Then check for width issues
              var images = node.querySelectorAll ? node.querySelectorAll('img[src*="width=1"], img[src*="width=30025"], img[src*="width=70"], img[src*="width=80"], img[data-src*="width=1"], img[data-src*="width=30025"], img[data-src*="width=70"], img[data-src*="width=80"]') : [];
              if (images.length > 0) needsFix = true;
            }
          });
        }
      });
      
      if (needsFix) {
        var now = Date.now();
        if (now - lastFixTime < fixThrottle) {
          // Throttle: clear pending fix and schedule new one
          if (pendingFix) clearTimeout(pendingFix);
          pendingFix = setTimeout(function() {
            lastFixTime = Date.now();
            fixAllImages();
            pendingFix = null;
          }, fixThrottle - (now - lastFixTime));
        } else {
          // Execute immediately
          lastFixTime = now;
          setTimeout(fixAllImages, 100);
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Additional fix for any remaining issues
    setTimeout(fixAllImages, 1000);
    setTimeout(fixAllImages, 3000);
    }
    
    // Retry mechanism if T4SThemeSP isn't ready yet
    var I = (window.T4SThemeSP && T4SThemeSP.Images) || null;
    if (!I) {
      // Wait for T4SThemeSP to be available (max 5 seconds)
      var attempts = 0;
      var maxAttempts = 50; // 50 attempts * 100ms = 5 seconds
      var checkInterval = setInterval(function() {
        attempts++;
        I = (window.T4SThemeSP && T4SThemeSP.Images) || null;
        if (I || attempts >= maxAttempts) {
          clearInterval(checkInterval);
          if (!I) {
            console.warn('🔇 T4SThemeSP.Images not available after retries, skipping image patch');
            return;
          }
          // Continue with patching
          patchImages();
        }
      }, 100);
      return;
    }
    
    // T4SThemeSP is available, patch immediately
    patchImages();
    
  } catch(e) { 
    console.error('Image patch error:', e);
  }
})();
